import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/analytics'

const firebaseConfig = {
    apiKey: process.env.VUE_APP_FB_API_KEY,
    authDomain: "angfiretest-ec6ba.firebaseapp.com",
    databaseURL: "https://" + process.env.VUE_APP_PROJECT_ID + ".firebaseio.com",
    projectId: process.env.VUE_APP_PROJECT_ID,
    storageBucket: process.env.VUE_APP_PROJECT_ID + ".appspot.com",
    messagingSenderId: "1056825165462",
    appId: process.env.VUE_APP_FB_ID,
    measurementId: "G-D7TP5EKY4G"
}

firebase.initializeApp(firebaseConfig)

firebase.analytics()

const auth = firebase.auth()

const db = firebase.firestore()

export {
    auth,
    db,
}

